import { Box, Grid } from '@mui/material';
import { EarningMechanismFragment } from '@occc/graphql';
import { InfoField } from '@occc/ui-design-system';
import { getVoucherAward } from '@occc-app/offerHelpers/utils';

import {
  arrangeNodeGroups,
  renderNodeGroups,
} from '@occc-app/routes/CampaignComponents/component-details/sections/utils';
import { FuelOfferFulfillmentsApproximationNote } from './fuel-offer-fulfillments-approximation.note';
import { SectionCard } from '../../components';
import { BLOCKS_IN_ROW } from '../constants';

const getVoucherFulfillmentsCount = (
  earningMechanism?: EarningMechanismFragment | null,
): number => {
  const voucherAward = getVoucherAward(earningMechanism);
  return voucherAward?.voucheredOffer.fulfillmentCount ?? 0;
};

type FulfilmentsSectionProps = {
  fulfillmentCount: number | string | null;
  earningMechanism?: EarningMechanismFragment | null;
  isFuelRollbackOffer?: boolean;
};

export const FulfilmentsSection = ({
  fulfillmentCount,
  earningMechanism,
  isFuelRollbackOffer,
}: FulfilmentsSectionProps) => {
  const voucherFulfillmentsCount = getVoucherFulfillmentsCount(earningMechanism);

  const secondaryNodes = [
    voucherFulfillmentsCount > 0 && (
      <InfoField label='Voucher Fulfillments' value={voucherFulfillmentsCount} />
    ),
  ];

  if (isFuelRollbackOffer) {
    const secondaryBlocks = arrangeNodeGroups(secondaryNodes, BLOCKS_IN_ROW);

    return (
      <SectionCard title='Fulfillments'>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Box display='flex' alignItems='center' gap={2} width='100%'>
              <InfoField label='Offer Fulfillments' value={fulfillmentCount} />
              <Box ml='auto'>
                <FuelOfferFulfillmentsApproximationNote />
              </Box>
            </Box>
          </Grid>
        </Grid>
        {secondaryBlocks.length > 0 && renderNodeGroups(secondaryBlocks, BLOCKS_IN_ROW)}
      </SectionCard>
    );
  }

  const blockGroups = arrangeNodeGroups(
    [<InfoField label='Offer Fulfillments' value={fulfillmentCount} />, ...secondaryNodes],
    BLOCKS_IN_ROW,
  );

  return blockGroups.length ? (
    <SectionCard title='Fulfillments'>{renderNodeGroups(blockGroups, BLOCKS_IN_ROW)}</SectionCard>
  ) : null;
};
